import axiosInstance from "./axiosService";
import serverUrl from "../config/serverUrl.js";

const API_URL = serverUrl;

export const createOrder = async (orderData) => {
  const response = await axiosInstance.post(`${API_URL}/order`, orderData);
  return response.data;
};

export const getOrder = async () => {
  const response = await axiosInstance.get(`${API_URL}/order`);
  return response.data;
};

export const getOrderById = async (id) => {
  const response = await axiosInstance.get(`${API_URL}/order/${id}`);
  return response.data.data;
};

export const initiatePayUPayment = async (order) => {
  try {
    const names = order.items
      .map((item) => item.productId.productName)
      .join(", ");
    const response = await axiosInstance.post(
      `${API_URL}/payment/payu/create`,
      {
        totalAmount: order.totalAmount,
        productInfo: names,
        userId: order.userId,
        orderId: order._id,
        address: order.shippingAddress,
      },
    );

    return response.data;
  } catch (error) {
    console.error("Payment initiation failed:", error);
    throw error;
  }
};

// Create Razorpay Order
export const createRazorpayOrder = async (orderId, totalAmount) => {
  try {
    const response = await axiosInstance.post(
      `${API_URL}/payment/razorpay/create-order`,
      {
        orderId,
        totalAmount,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error creating Razorpay order:", error);
    throw error;
  }
};

// Verify Razorpay Payment
export const verifyRazorpayPayment = async (paymentData) => {
  try {
    const response = await axiosInstance.post(
      `${API_URL}/payment/razorpay/verify`,
      paymentData,
    );
    return response.data;
  } catch (error) {
    console.error("Error verifying Razorpay payment:", error);
    throw error;
  }
};
